import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LoadingButton from "../components/LoadingButton";
import api from "../services/api";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.requestPasswordReset({ email });
      if (res?.success) {
        setSuccess(true);
      } else {
        setError(res?.message || t("forgot_password.error_generic"));
      }
    } catch (err) {
      setError(
        err.response?.data?.message || t("forgot_password.error_generic")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md bg-white p-8 rounded-3xl border border-white/60 shadow-lg">
        <h2 className="text-2xl font-bold mb-2">
          {t("forgot_password.title", "Forgot Password")}
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          {t(
            "forgot_password.subtitle",
            "Enter your registered email to receive a temporary password by email."
          )}
        </p>
        {success ? (
          <div>
            <div className="mb-4 p-4 bg-green-50 border border-green-100 text-green-700 rounded">
              {t(
                "forgot_password.sent_message",
                "If your email is registered, a temporary password was sent to your inbox."
              )}
            </div>
            <div className="text-center">
              <Link
                to="/login"
                className="text-primary-600 hover:text-primary-700 font-medium"
              >
                {t("login.back_to_login", "← Back to login")}
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {t("login.email", "Email")}
              </label>
              <input
                type="email"
                className="mt-1 w-full border border-gray-200 p-3 rounded-xl"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("login.email_placeholder", "name@company.com")}
                required
              />
            </div>
            {error && <div className="text-red-600 text-sm">{error}</div>}
            <div className="flex items-center justify-between">
              <Link to="/login" className="text-sm text-primary-600">
                {t("login.back_to_login", "← Back to login")}
              </Link>
              <LoadingButton
                type="submit"
                loading={loading}
                className="bg-primary-600 text-white px-4 py-2 rounded-xl"
              >
                {t("forgot_password.send_button", "Send")}
              </LoadingButton>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
